import { push } from 'connected-react-router'

export const loadPackagesBySupplierId = (supplierId, clientId) => ({
  type: 'FETCH_PACKAGES_BY_SUPPLIERID',
  payload: {
    client: 'mileageApi',
    request: {
      method: 'get',
      url: `/mileage-api/v1/packages/${supplierId}/${clientId}`
    }
  }
})

export const authorizeWithTokenMileage = (
  OrderId,
  Token,
  OrderMileageId,
  VendorId,
  lastTry
) => ({
  type: 'MILEAGE_WITH_TOKEN',
  payload: {
    client: 'mileageApi',
    request: {
      method: 'post',
      url: `/mileage-api/v1/orders/withToken?orderId=${OrderId}&token=${Token}&orderMileageId=${OrderMileageId}`
    }
  },
  supplierId: VendorId,
  lastTry
})

export const closeErrorMileage = () => ({
  type: 'REDEMPTION_MILEAGE_CLOSE_ERROR'
})

export const mileageRedemption = (order, supplierId) => ({
  type: 'REDEMPTION_MILEAGE',
  payload: {
    client: 'mileageApi',
    request: {
      method: 'post',
      url: `/mileage-api/v1/orders/redemption`,
      data: order
    }
  },
  supplierId
})

export const navigateToServiceConfirmation = liveOrderId => {
  return (dispatch) => {
    dispatch(
      push(`/services/confirmation/${liveOrderId}`)
    )
  }
}

export const redemptionFuelCredit = client => (order, state) => {
  return (dispatch, getState) => {
    const {
      oidc: { user }
    } = getState()
    if (!user) {
      dispatch(push('/auth/login'))
    } else {
      dispatch({ type: 'REDEMPTION_FUEL_CREDIT' })
    }

    dispatch(mileageRedemption(order, state.shellSupplierId))
  }
}

export const closeError = () => ({ type: 'REDEMPTION_FUEL_CREDIT_CLOSE_ERROR' })

export const changeStepFuelCredit = step => {
  return dispatch => {
    dispatch({
      type: 'CHANGE_STEP_FUEL_CREDIT',
      step
    })
  }
}

export const redirectFuelCreditError = (descriptionErrorFuelCredit, state) => {
  return dispatch => {
    dispatch({
      type: 'REDIRECT_ERROR_FUEL_CREDIT',
      descriptionErrorFuelCredit,
      packageSelected: state.packageSelected
    })
    dispatch(push(`/fuelcredit`))
  }
}

export default client => ({
  loadPackagesBySupplierId,
  redemptionFuelCredit: redemptionFuelCredit(client),
  authorizeWithTokenMileage: authorizeWithTokenMileage,
  closeError,
  closeErrorMileage,
  changeStepFuelCredit,
  redirectFuelCreditError,
  navigateToServiceConfirmation
})



// WEBPACK FOOTER //
// ./src/features/Services/FuelCredit/actions.js